import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconHalfSun(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-half_sun_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M13,31H39a1,1,0,0,0,1-1,14,14,0,0,0-28,0A1,1,0,0,0,13,31Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M5,31H9a1,1,0,0,0,0-2H5a1,1,0,0,0,0,2Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M43,31h4a1,1,0,0,0,0-2H43a1,1,0,0,0,0,2Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M26,14a1,1,0,0,0,1-1V9a1,1,0,0,0-2,0v4A1,1,0,0,0,26,14Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13.27,18.69A1,1,0,0,0,14,19a1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.42l-2.83-2.83a1,1,0,1,0-1.42,1.42Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M38,19a1,1,0,0,0,.71-.29l2.83-2.83a1,1,0,1,0-1.42-1.42l-2.83,2.83a1,1,0,0,0,0,1.42A1,1,0,0,0,38,19Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M47,35H5a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M39,41H13a1,1,0,0,0,0,2H39a1,1,0,0,0,0-2Z"
      }));
    }
  }));
}
export default SvgIconHalfSun;